module.exports = ".side-menu {\n    height: 100%;\n}\n\n.container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.left-panel {\n    padding: 6px 12px;\n}\n\n.right-panel {\n    margin-right: 64px;\n    padding: 6px 0;\n    margin-bottom: 75px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/main-view/main-view.component.css
// module id = ./src/app/components/main-view/main-view.component.css
// module chunks = main